<template>
  <div class="tabs" v-if="tabs.length > 1" id="tabs">
    <ul class="tab-wrap" :class="{ 'tab-scroll': scrollable }" ref="tab">
      <router-link class="tab-item" tag="li" :to="{ path: tab.path, query: getParams(tab.name, tab.path) }" replace v-for="(tab, index) in tabs" :key="index" @click.native="onClick(tab.index, tab.name)">
        <!-- <span>{{ TLang(tab.name, "result") }}</span> -->
        <span>{{ getTabName(tab) }}</span>
      </router-link>
    </ul>
  </div>
</template>

<script>
import { raf } from '../utils/raf.js';
import { checkUnifyShop, getQueryString, unionFlag } from '../utils';
import { publicFunc } from '../utils/func';
import eventBus from '@/assets/js/eventBus';
export default {
  props: {
    tabs: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      duration: 0.3,
      swipeThreshold: 6,
      index: 0,
    };
  },
  computed: {
    scrollable() {
      return this.tabs.length > this.swipeThreshold;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.changeRoute();
      this.scrollIntoView(true);
    });
    // 全部下查看更多跳到体检机构
    eventBus.$on('clickMore', (type) => {
      const cTab = this.tabs.find((item) => item.name === type);
      if (type === '体检机构') {
        this.onClick(cTab.index, cTab.name);
      }
    });
  },
  methods: {
    getParams(name, path) {
      if (path === 'home' && !this.$route.query['productTypes']) {
        return { ...this.$route.query };
      } else {
        return { ...this.$route.query, productTypes: name };
      }
    },
    scrollIntoView(immediate) {
      if (!this.scrollable || !this.tabs.length) {
        return;
      }

      const i = this.getIndex();
      const tab = this.$refs.tab;
      if (!tab) return;
      const items = tab.children;
      const tabLeft = tab.scrollLeft;
      const tabWidth = tab.offsetWidth;
      const item = items[i];
      const itemLeft = item && item.offsetLeft;
      const itemWidth = item && item.offsetWidth;

      this.scrollTo(tab, tabLeft, itemLeft - (tabWidth - itemWidth) / 2, immediate);
    },
    getIndex() {
      const path = location.pathname.replace('/ms', '');
      const name = path.substring(1);
      return this.tabs.findIndex((tab) => tab.path === name);
    },
    scrollTo(el, from, to, immediate) {
      if (immediate) {
        el.scrollLeft += to - from;
        return;
      }

      let count = 0;
      const frames = Math.round((this.duration * 1000) / 16);
      const animate = function animate() {
        el.scrollLeft += (to - from) / frames;
        if (++count < frames) {
          raf(animate);
        }
      };

      animate();
    },
    onClick(index, type) {
      if (this.index === index) return;
      this.$emit('handlerClear', { needLocation: 2, location: JSON.parse(localStorage.getItem('systemLoaction')) || null }, 1);
      const { query } = this.$route;
      this.index = index;
      // 切换频道 暂不改变卡选中状态
      // const path = window.location.pathname.replace("/ms/", "");
      // let cardChoose = getQueryString("cardChoose") || 0;
      // if (path != this.tabs[index].path) {
      //   cardChoose = 0;
      // }
      // this.$router
      //   .push({
      //     name: this.tabs[index].path,
      //     // query: { ...query, index, productTypes: type, cardChoose: cardChoose }
      //     query: { ...query, index, productTypes: type },
      //   })
      //   .catch(() => {});

      this.scrollIntoView();
    },
    changeRoute(immediate) {
      // const { query } = this.$route;
      const path = location.pathname.replace('/ms', '');
      const query = {};
      decodeURIComponent(location.search)
        .replace('?', '')
        .split('&')
        .map((item) => item.split('='))
        .map((item) => (query[item[0]] = item[1]));
      let def = this.tabs.filter((tab) => {
        return tab.defaultFlag;
      });

      if (!def && this.tabs.length > 0) {
        const list = [...this.tabs];
        def = list.length > 1 ? list.splice(1, list.length) : list;
      }

      if (immediate) {
        // 当tabs的数据发生的变化
        this.index = def[0].index;
        this.$router
          .replace({
            name: def[0].path,
            query,
          })
          .catch(() => {});
      } else {
        // 页面返回进来或刷新走这里
        if (path.substr(1)) {
          this.index = query.index ? query.index : def[0].index;
          this.$router
            .replace({
              name: path.substr(1),
              query,
            })
            .catch(() => {});
        } else {
          // 第一次初始化走这里
          this.index = def[0].index;
          this.$router
            .replace({
              name: def[0].path,
              query,
            })
            .catch(() => {});
        }
      }
    },
    getDFLANG() {
      const union = unionFlag() || sessionStorage.getItem('dffl_union');
      return union || checkUnifyShop();
    },
    // 判断Tab展示中文还是英文，英文状态下，接口返回的text为英文频道名
    getTabName(info) {
      let nameStr = this.TLang(info.name, 'result');
      if (info.name == '全部' || info.name == 'all') {
        return nameStr;
      }

      nameStr = info.text;

      return nameStr;
    },
  },
  watch: {
    tabs() {
      this.scrollIntoView(true);
      // this.changeRoute(true);
    },
    $route() {
      this.scrollIntoView(true);
    },
  },
};
</script>

<style lang="less" scoped>
@375: 320/375;
.tabs {
  height: 40px * @375;
  // background-color: #1e4c9c;
  // background: linear-gradient(270deg, #5cb4ec 0%, #3FA6FF 100%);
  background: #fff;
  overflow: hidden;
  padding-left: 5px * @375;
}
.tab {
  &-wrap {
    display: flex;
    // padding-bottom: 15px;
    overflow: hidden;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  &-item {
    // flex: 1;
    box-sizing: border-box;
    padding-left: 10px;
    padding-right: 10px;
    text-align: center;
    font-size: 16px * @375;
    color: #333;
    height: 40px * @375;
    > span {
      position: relative;
      display: inline-block;
      height: 40px * @375;
      line-height: 40px * @375;
      .ellipsis();
    }
    &__active {
      color: #3fa6ff;
      font-weight: 500;
      > span {
        &:after {
          .setBottomLine(#3fa6ff);
          left: 50%;
          max-width: 18px * @375;
          height: 3px * @375;
          bottom: 6px * @375;
          transform: scaleY(2) translate(-50%);
          animation: ani 0.3s linear forwards;
        }
      }
    }
  }
  &-scroll {
    .tab-item {
      flex: 0 0 14%;
    }
  }
}
@keyframes ani {
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
}
</style>
